import React, {useState} from "react";

const {CustomDropdown, DropdownButton, Dot, ArrowIcon} = require("@pages/new-design-components/custom-components");
const {DropdownMenu, DropdownItem} = require("reactstrap");

export default function CustomDamageDropDown({selectedTitle,
                                                 labelKey = 'value',
                                                 valueKey = 'key',
                                                 emptyTitle = 'Select',
                                                 handleChange, data = [], border = null,
                                                 disabled, hoverColor = ''})  {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const selected =
        !selectedTitle
            ? { [labelKey]: emptyTitle }
            : data.find(item => item[valueKey] === selectedTitle) || { [labelKey]: emptyTitle };
    return ( <CustomDropdown minWidth={'250px'} isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownButton hoverColor={hoverColor} className={'w-100'} border={border} disabled={disabled}>
                <div className={'d-flex align-items-center g-5'}>
                    <Dot color={selected.color} /> {selected[labelKey] || '-'}
                </div>
                <ArrowIcon
                    isOpen={dropdownOpen}
                    src={require("assets/images/arrow_forward_ios.png")}
                    alt="Dropdown Arrow"
                />
            </DropdownButton>
            <DropdownMenu className={'w-100'}>

                {data.map((title,idx) => (
                    <DropdownItem  key={`${title[valueKey]}_${idx}_0`} onClick={() => {
                        handleChange(title[valueKey])
                        setDropdownOpen(false);
                    }}>
                        <Dot color={title?.color} />
                        {title[labelKey]}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </CustomDropdown>
    )
}
